"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack = ({ children, space = 2, direction = 'column', spaceBetween, flexWrap, center, className }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `d-flex flex-${direction} gap-${space} ${spaceBetween ? 'justify-content-between' : ''} ${flexWrap ? 'flex-wrap' : ''} ${center ? 'align-items-center' : ''} ${className || ''}`, children: children }));
};
exports.Stack = Stack;
